
<template>
  <v-autocomplete
                  v-model="value"
                  v-model:search="searchText"
                  :items="validEvents"
                  :loading="loading"
                  item-title="name"
                  item-value="id"
                  hide-details
                  :label="label"
                  clearable
                  :return-object="returnObject"
                  density="compact">
    <template v-slot:no-data>
      <div class="px-4">Digite sua busca</div>
    </template></v-autocomplete>
</template>
<script>
import api from '@/services'

export default {
  components: {},
  props: {
    user: Object,
    label: String,
    modelValue: Object,
    returnObject: Boolean,
    showDisabled: Boolean,
    selectedId: Number,
  },
  emits: ["update:modelValue"],
  data() {
    return {
      requestingApi: false,
      lstObjects: [],
      searchText: null,
      previousSearch: "",
      loading: false,
      timeoutSearchDelay: null,
      enableSearch: false,
    };
  },
  created() {
    var vm = this;

    vm.submitSearch();
  },
  mounted() { },
  activated() { },
  methods: {
    waitAndSearch() {
      var vm = this;
      if (vm.timeoutSearchDelay) {
        clearTimeout(vm.timeoutSearchDelay);
      }
      if (vm.searchText != "" && vm.searchText != " ") {
        vm.timeoutSearchDelay = setTimeout(() => {
          vm.submitSearch();
        }, 1000);
        vm.loading = true;
      }
    },
    submitSearch() {
      var vm = this;
      if (!vm.requestingApi) {
        let _searchText = vm.searchText;
        if (vm.enableSearch) {
          let _prev = (vm.previousSearch || "").toUpperCase();
          let _act = (_searchText || "").toUpperCase();
          if (_act == "" || (_act == " " && _prev == _act)) {
            vm.loading = false;
            return;
          }
        }
        vm.requestingApi = true;
        vm.loading = true;
        return new Promise((resolve, reject) => {
          // itemsPerPage: 30 -> NA API de eventos o list está fixo em 30
          // busca somente por eventos que não ocorreram ainda
          api.event
            .list({ searchText: _searchText , statuses: [0]}, 1)
            .then((result) => {
              vm.lstObjects = result?.data || result || [];
              if (vm.lstObjects?.length >= 30) {
                vm.enableSearch = true;
              }
            })
            .catch((err) => {
              //
            })
            .finally(() => {
              vm.requestingApi = false;
              vm.loading = false;
              if (vm.selectedId) {
                vm.changeSelectedEvent(vm.selectedId);
              }
            });
        });
      }
    },
    changeSelectedEvent(newVal) {
      const vm = this;

      if (newVal && !isNaN(newVal) && vm.validEvents?.length > 0) {
        const found = vm.validEvents.find(pm => pm.id == newVal);
        if (found) vm.value = found;
      }
    }
  },
  computed: {
    validEvents() {
      const vm = this;
      const list = Array.isArray(vm.lstObjects) ? [...vm.lstObjects] : [];
      const current = vm.modelValue;
      if (current && typeof current === "object" && current.id != null) {
        if (!list.some((e) => e.id == current.id)) {
          list.unshift(current);
        }
      }
      return list
    },
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    searchText(newVal, oldVal) {
      if (
        newVal &&
        newVal != " " &&
        newVal.toUpperCase() != oldVal?.toUpperCase()
      ) {
        if (this.enableSearch) {
          this.waitAndSearch();
        }
      }
    },
    selectedId: {
      handler(newVal) {
        this.changeSelectedEvent(newVal);
      },
      immediate: true
    }
  },
};
</script>
